
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SessionTimeoutModule } from './life-client/session-timeout/session-timeout.module';
import { SharedModule } from './shared/shared.module';
import { environmentconfig } from '../config/env-config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EntWindowRefService, EntClipboardService  } from '@ng/ent-utilities';
import { SafePipe } from 'app/pipes/safe.pipe';
import { EntLoaderModule } from '@ng/ent-components/ent-loader';
import { InterceptorsProviders } from './core/interceptors/interceptors.providers';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    EntLoaderModule,
    // EntUtilitiesModule,
    SessionTimeoutModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {provide: 'ENG_CONFIG', useValue: environmentconfig.getEnvConfig()},
    EntWindowRefService,
    EntClipboardService,
    InterceptorsProviders, 
    provideNgxMask({ dropSpecialCharacters: true, validation: false }),
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [ AppComponent ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
